var _Path, _Path2, _Path3, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgMentalHealth = function SvgMentalHealth(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 57 56"
  }, props), /*#__PURE__*/React.createElement(G, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    clipPath: "url(#mentalHealth_svg__a)"
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M33.073 17.372a12.7 12.7 0 0 0-2.461-3.488 12.5 12.5 0 0 0-2.345 3.243"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M23.378 20.639a12.6 12.6 0 0 0-5.763-1.4c0 6.976 5.658 12.635 12.635 12.635h.712c6.976 0 12.635-5.659 12.635-12.635-2.124 0-4.119.525-5.88 1.458a12.5 12.5 0 0 0-1.26-5.763 12.5 12.5 0 0 0-3.465 2.485 12.8 12.8 0 0 0-2.38 3.371 12.7 12.7 0 0 0-2.38-3.371 12.4 12.4 0 0 0-3.465-2.485 12.8 12.8 0 0 0-1.272 5.483l.023.292-.14-.059z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M30.332 32.107V50.75h10.301s-1.481-6.837-.851-11.678 7.151-8.284 7.151-17.115c0-8.832-5.18-17.208-18.048-17.208s-15.482 12.04-15.482 14.338v5.157L9.88 31.488c-.338.654-.362 1.75.56 1.82l3.045.654v6.276s-.14 5.25 6.86 4.656c0 0 2.742.35 2.928 2.87v3.523"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "mentalHealth_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M.5 0h56v56H.5z"
  })))));
};
export default SvgMentalHealth;